import './Footer.css';
import Logo from '../Logo/Logo';
import { IconeInstagram, IconeLinkedIn, IconeWhatsApp } from '../Icones/Icones';
import { INSTAGRAM_URL, LINKEDIN_URL, TORQUE_DEMO_URL, WHATSAPP_EXIBICAO, linkWhatsApp } from '../../config';

function Footer() {
    return (
        <footer className="footer">
            <div className="container footer-grade">
                <div className="footer-marca">
                    <Logo />
                    <p>Software sob medida e produtos próprios.</p>
                </div>

                <nav className="footer-coluna" aria-label="Sistemas">
                    <h2>Sistemas</h2>
                    <ul>
                        <li><a href={TORQUE_DEMO_URL} target="_blank" rel="noopener noreferrer">Torque: demonstração</a></li>
                        <li><a href="#sistemas">Gerenciador de Transportes</a></li>
                        <li><a href="#sob-demanda">Projetos sob demanda</a></li>
                    </ul>
                </nav>

                <div className="footer-coluna">
                    <h2>Contato</h2>
                    <a
                        href={linkWhatsApp('Olá! Vim pelo site da C1010.')}
                        className="footer-whatsapp"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <IconeWhatsApp tamanho={18} />
                        {WHATSAPP_EXIBICAO}
                    </a>
                    <div className="footer-redes">
                        <a href={linkWhatsApp()} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                            <IconeWhatsApp tamanho={20} />
                        </a>
                        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <IconeInstagram tamanho={20} />
                        </a>
                        <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                            <IconeLinkedIn tamanho={20} />
                        </a>
                    </div>
                </div>
            </div>

            <div className="container footer-base">
                <p>© {new Date().getFullYear()} C1010 Sistemas</p>
            </div>
        </footer>
    );
}

export default Footer;
